module.exports = __webpack_public_path__ + "media/npc_dota_hero_wisp.b1d3fb88.webm";